import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from '../models/api-response.model';
import { Item } from '../models/item.model';
import { ListViewItem } from '../models/list-view-item.model';

export interface BulkArchiveItemsResponse {
  result: {
    archived: number[];
    already_archived: number[];
  };
  error: Record<string, unknown>;
}

@Injectable({
  providedIn: 'root'
})
export class ItemService {
  constructor(private httpClient: HttpClient) {}

  createItem(item: Item, params: object): Observable<ApiResponse<Item>> {
    return this.httpClient.post<ApiResponse<Item>>(this.getCreateUri(), item, this.getOptions(params));
  }

  editItem(item: Item, params: object): Observable<ApiResponse<Item>> {
    return this.httpClient.put<ApiResponse<Item>>(this.getRequestUri(item.id), item, this.getOptions(params));
  }

  getItem(itemId: string): Observable<ApiResponse<Item>> {
    return this.httpClient.get<ApiResponse<Item>>(this.getRequestUri(itemId), this.getOptions());
  }

  getItems(params: object): Observable<ApiResponse<ListViewItem[]>> {
    return this.httpClient.get<ApiResponse<ListViewItem[]>>(this.getCreateUri(), this.getOptions(params));
  }

  deleteItem(itemId: string | number): Observable<ApiResponse<null>> {
    return this.httpClient.delete<ApiResponse<null>>(this.getRequestUri(itemId), this.getOptions());
  }

  bulkArchiveItems(itemIds: Array<string | number>): Observable<BulkArchiveItemsResponse> {
    return this.httpClient.patch<BulkArchiveItemsResponse>(
      environment.apiUri + '/finance/items/bulk_archive',
      { item_ids: itemIds },
      this.getOptions()
    );
  }

  unarchiveItem(itemId: string | number): Observable<ApiResponse<null>> {
    return this.httpClient.patch<ApiResponse<null>>(this.getRequestUri(itemId) + '/unarchive', {}, this.getOptions());
  }

  protected getRequestUri(itemId: string | number): string {
    return environment.apiUri + '/finance/items/' + itemId;
  }

  protected getCreateUri(): string {
    return environment.apiUri + '/finance/items';
  }

  private getOptions(params?: object): object {
    return {
      params,
      withCredentials: true,
      headers: {
        Accept: 'application/json'
      }
    };
  }
}
